import { PageHeader } from 'components/PageHeader';
import { PageHeaderSkeleton } from 'components/PageHeaderSkeleton';
import { getTransWithParams } from 'modules/i18n';
import { getWeekLabelWithTimezone } from 'modules/work-weeks';
import { DEFAULT_TIMEZONE } from 'utils/date';
import { useWeekDetails, useWeekPeriod } from '../hooks';

export const WeekDetailsHeader = () => {
  const { weekPeriod, isLoading } = useWeekPeriod();
  const { isError, isLoading: isWeekDetailsLoading } = useWeekDetails();

  if (isLoading) {
    return <PageHeaderSkeleton subtitle={true} withBackBtn />;
  }

  if ((!weekPeriod || isError) && !isWeekDetailsLoading) {
    return <PageHeader withBackBtn />;
  }

  const start = weekPeriod?.calendarWeekStart;
  const end = weekPeriod?.calendarWeekEnd;
  const dateLabelWithTimezone =
    start && end ? getWeekLabelWithTimezone(start, end, DEFAULT_TIMEZONE) : '';

  return (
    <PageHeader
      title={getTransWithParams('abbreviations.calendarWeekWithNumber', {
        weekNumber: weekPeriod?.calendarWeek
      })}
      subtitle={dateLabelWithTimezone}
      withBackBtn
    />
  );
};
